import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CheckboxChecked = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 26 26">
    <rect
      x="1"
      y="1"
      width="24"
      height="24"
      rx="4"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M9.95599 12.3372C9.44268 11.8092 8.59854 11.7974 8.07056 12.3107C7.54258 12.824 7.53069 13.6681 8.04401 14.1961L9.95599 12.3372ZM12.6296 17L11.6736 17.9294L12.7876 19.0752L13.7153 17.774L12.6296 17ZM19.419 9.77403C19.8465 9.17444 19.707 8.34183 19.1074 7.91434C18.5078 7.48686 17.6752 7.62638 17.2477 8.22597L19.419 9.77403ZM8.04401 14.1961L11.6736 17.9294L13.5856 16.0706L9.95599 12.3372L8.04401 14.1961ZM13.7153 17.774L19.419 9.77403L17.2477 8.22597L11.544 16.226L13.7153 17.774Z"
      fill="white"
    />
  </SvgIcon>
));

export default CheckboxChecked;
